import { showAlert } from "@erp/shared/utils/dialog";
function createFileTypeChecker(validate, errorMessage) {
    return function (files, self) {
        return new Promise((resolve) => {
            if (!files) {
                resolve(false);
                return;
            }
            const fileList = Array.isArray(files) ? files : [files];
            for (const file of fileList) {
                if (!validate(file)) {
                    showAlert(errorMessage);
                    if (Array.isArray(files)) {
                        files.length = 0;
                    }
                    else {
                        self.reset();
                        self.$el.querySelector('input[type="file"]').value = "";
                    }
                    resolve(false);
                    return;
                }
            }
            resolve(true);
        });
    };
}
const IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg"];
const PDF_OR_IMAGE_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
];
export const checkTypeImage = createFileTypeChecker((file) => IMAGE_TYPES.includes(file.type), "허용되지 않는 파일 형식입니다. jpeg, jpg, png 확장자의 이미지 파일만 첨부 가능합니다.");
export const checkTypePdf = createFileTypeChecker((file) => file.type === "application/pdf", "허용되지 않는 파일 형식입니다. pdf 파일만 첨부 가능합니다.");
export const checkTypePdfOrImage = createFileTypeChecker((file) => PDF_OR_IMAGE_TYPES.includes(file.type), "허용되지 않는 파일 형식입니다. PDF 또는 이미지(jpg, png, webp) 파일만 첨부 가능합니다.");
export const checkTypeExcel = createFileTypeChecker((file) => {
    const ext = file.name.split(".").pop();
    return ext === "xlsx" || ext === "xls";
}, "허용되지 않는 파일 형식입니다. xlsx, xls 확장자의 엑셀 파일만 첨부 가능합니다.");
